var map = {
	"./appsrore.png": "V8L4",
	"./appstore.svg": "4GxG",
	"./bg-home.svg": "M1FS",
	"./blue.svg": "MuI8",
	"./close.svg": "6LxQ",
	"./efficace.svg": "GxgT",
	"./googleplay.png": "k9Qe",
	"./googleplay.svg": "ZRMn",
	"./local.svg": "ovGn",
	"./overtflow.svg": "Iy4i",
	"./players.svg": "zEpJ",
	"./purple.svg": "3eNH",
	"./rapide.svg": "GpMY",
	"./red-x.svg": "sTdo",
	"./red.svg": "B+ek",
	"./remainder.svg": "A1a1",
	"./simple.svg": "rgRA",
	"./video-pack.png": "wLE+"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KDBp";